'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { useState, useCallback, useRef, useEffect } from 'react';
import styles from '../app/(frontend)/artikel/artikel.module.css';

export default function ArticleSearch() {
    const router = useRouter();
    const searchParams = useSearchParams();
    const currentQuery = searchParams.get('q') || '';
    const [query, setQuery] = useState(currentQuery);
    const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    // Sync input with URL changes (e.g. browser back/forward)
    useEffect(() => {
        setQuery(currentQuery);
    }, [currentQuery]);

    const handleSubmit = useCallback((e: React.FormEvent) => {
        e.preventDefault();
        const trimmed = query.trim();
        if (trimmed) {
            router.push(`/artikel?q=${encodeURIComponent(trimmed)}`);
        } else {
            router.push('/artikel');
        }
    }, [query, router]);

    const handleClear = useCallback(() => {
        setQuery('');
        router.push('/artikel');
    }, [router]);

    return (
        <form onSubmit={handleSubmit} className={styles.searchForm} role="search">
            <div className={styles.searchInputWrapper}>
                <svg
                    className={styles.searchIcon}
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
                <input
                    type="search"
                    name="q"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Cari artikel..."
                    className={styles.searchInput}
                    autoComplete="off"
                />
                {query && (
                    <button
                        type="button"
                        onClick={handleClear}
                        className={styles.searchClear}
                        aria-label="Hapus pencarian"
                    >
                        ✕
                    </button>
                )}
            </div>
            <button type="submit" className={styles.searchButton}>
                Cari
            </button>
        </form>
    );
}
